import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import KenButton from '../KenButton';

export default function AlertDialog({
  title,
  openDialog,
  setOpenDialog,
  message,
  okText,
  notOkText,
  handleDialogSubmit,
  children,
  width,
  alignTitle,
}) {
  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <div>
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        fullWidth={true}
        maxWidth={width}
      >
        <div style={{ padding: 16 }}>
          <DialogTitle id='alert-dialog-title'>
            <Typography
              variant='body2'
              style={{
                display: 'flex',
                fontSize: 16,
                justifyContent: alignTitle ? alignTitle : 'center',
              }}
            >
              {title}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {children}
              {message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <KenButton onClick={handleClose} variant='secondary'>
              {notOkText}
            </KenButton>
            <KenButton onClick={handleDialogSubmit} variant='primary' autoFocus>
              {okText}
            </KenButton>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}
